import { CanDeactivateFn } from '@angular/router';

export interface HasUnsavedChanges {
  hasUnsavedChanges(): boolean;
}

/**
 * Asks before any in-app navigation away from a view with unsaved work. Closing the tab
 * is covered separately by LockNavigationService (beforeunload).
 */
export const UnsavedChangesGuard: CanDeactivateFn<HasUnsavedChanges> = (
  component
) =>
  !component?.hasUnsavedChanges() ||
  confirm('Sie haben ungespeicherte Änderungen. Seite verlassen?');
